/* eslint-disable  */
import qs from 'qs';
import {getPaginationFromMeta} from '../utils/commonFunctions';

export const GET_MY_STORES_LIST_REP_PENDING = 'GET_MY_STORES_LIST_REP_PENDING';
export const GET_MY_STORES_LIST_REP_REJECTED = 'GET_MY_STORES_LIST_REP_REJECTED';
export const GET_MY_STORES_LIST_REP_FULFILLED = 'GET_MY_STORES_LIST_REP_FULFILLED';

const initialState = {
  performances: {
    stock_it: [],
    display_it: [],
    price_it: [],
    sell_it: []
  },
  rbmCodes: [],
  rbmLoading: false,
  stores: [],
  repOutlets: [],
  repPaging: {
    number: 1,
    size: 20,
  },
  paging: {
    number: 1,
    size: 20,
  },
  markers: [],
  vouchers: [],
  fetching: false,
  fetched: false,
  errors: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_STORE_PERFORMANCE_DATA_PENDING':
    case GET_MY_STORES_LIST_REP_PENDING:
    case 'GET_OUTLETS_PENDING':
    case 'GET_OUTLET_MAP_PENDING': {
      return {...state, fetching: true, fetched: false};
    }
    case GET_MY_STORES_LIST_REP_FULFILLED: {
      return {
        ...state,
        repOutlets: action.payLoad.data,
        repPaging: getPaginationFromMeta(initialState.repPaging, state.repPaging, action.payLoad.links),
      }
    }
    case 'GET_OUTLET_RBMS_PENDING': {
      return {
        ...state,
        rbmLoading: true,
      };
    }
    case 'GET_OUTLET_RBMS_FULFILLED': {
      return {
        ...state,
        rbmLoading: false,
        rbmCodes: action.payLoad,
      };
    }
    case 'GET_OUTLETS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stores: action.payLoad.data
      };
    }
    case 'GET_OUTLET_MAP_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        markers: action.payLoad.features
      };
    }
    case 'GET_ADMIN_OUTLETS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stores: action.payLoad.data,
        links: action.payLoad.links,
        paging: getPaginationFromMeta(initialState.paging, state.paging, action.payLoad.links),
      };
    }
    case 'GET_OUTLET_VOUCHERS_FULFILLED': {
      return {
        ...state,
        vouchers: action.payLoad,
      };
    }
    case 'GET_OUTLETS_REJECTED': {
      return {
        ...state, errors: action.payLoad
      };
    }
    case 'GET_STORE_PERFORMANCE_DATA_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        performances: action.payLoad,
      };
    }


    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/storeReducer.js